var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHuaweiActive = function SvgIcHuaweiActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-huawei-active_svg__ic-huawei-active",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__68rq9i6kla",
    d: "M11.543 14.568s.055-.044.025-.117h.002C7.823 6.258 2.698.044 2.698.044S-.09 2.693.108 5.346c.107 2.009 1.614 3.198 1.614 3.198 2.435 2.374 8.322 5.368 9.69 6.047.017.008.09.03.13-.023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__alz3tr565c",
    d: "M2.698.044s5.125 6.214 8.872 14.407h-.002c.03.073-.025.117-.025.117-.041.053-.114.031-.132.023-1.367-.679-7.254-3.673-9.689-6.047 0 0-1.507-1.19-1.614-3.198"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__pn6ca3n9yf",
    d: "M10.002.155c-.026-.089-.13-.089-.13-.089V.062l-9.8.343c1.063 1.898 2.855 3.37 4.72 2.92C6.078 3.003 8.991.968 9.955.278L9.953.276c.074-.067.049-.121.049-.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__faujod93sh",
    d: "M9.872.062v.004s.104 0 .13.089c0 0 .025.054-.049.12l.003.004c-.964.69-3.877 2.725-5.165 3.045C2.927 3.775 1.135 2.303.073.404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__dkfjvew3pk",
    d: "M13.055 7.62c.05-.076-.035-.144-.035-.144l.002-.001C8.717 4.567.372.106.372.106c-.758 2.35.265 4.241.265 4.241C1.699 6.6 3.729 7.28 3.729 7.28c.937.387 1.874.413 1.874.413.148.025 5.832.002 7.354-.005.065 0 .098-.067.098-.067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__yxo32ddb1m",
    d: "M.417.13c.663.355 8.485 4.561 12.605 7.345h-.002s.084.069.035.145c0 0-.033.067-.098.067-1.522.007-7.206.03-7.354.005 0 0-.937-.026-1.874-.413 0 0-2.03-.68-3.092-2.932 0 0-1.023-1.891-.265-4.241L.365.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__t8fgefdt8p",
    d: "M5.108.106C4.68.145 3.529.408 3.529.408.933 1.078.321 3.436.321 3.436c-.475 1.483.012 3.113.012 3.113.865 3.846 5.128 10.168 6.046 11.495.063.066.115.043.115.043.1-.027.093-.121.093-.121C7.997 3.85 5.107.106 5.107.106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__fewmyl35gr",
    d: "M5.108.106s2.888 3.744 1.479 17.86c0 0 .005.072-.06.108h-.111c-.012-.007-.024-.017-.037-.03-.918-1.327-5.18-7.649-6.046-11.495 0 0-.487-1.63-.012-3.113 0 0 .612-2.358 3.208-3.028"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__q9k06tg4gu",
    d: "M.51 18.083c.094.038.143-.054.143-.054h.003c.937-1.362 5.173-7.648 6.039-11.48 0 0 .465-1.859.013-3.113 0 0-.64-2.394-3.24-3.028 0 0-.747-.19-1.541-.302 0 0-2.905 3.745-1.493 17.869h.002c.01.091.075.108.075.108"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__5vpzxzcuow",
    d: "M1.927.106c.794.113 1.54.302 1.54.302 2.601.634 3.24 3.028 3.24 3.028.443 1.227.007 3.033-.012 3.11v.003C5.829 10.38 1.593 16.667.656 18.029H.653s-.012.022-.035.04H.485c-.02-.014-.043-.042-.049-.094H.434C-.949 4.133 1.812.26 1.924.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__46dfql4azz",
    d: "M.176.071S.088.082.064.147c0 0-.02.088.038.132v.003c.936.674 3.781 2.663 5.153 3.052 0 0 2.533.862 4.736-2.92L.176.07V.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__x8tumo0uyB",
    d: "M.66.087l9.297.325v.059C7.784 4.15 5.305 3.35 5.255 3.334 3.883 2.944 1.038.956.102.282V.279C.044.235.064.147.064.147c.012-.03.038-.05.062-.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__448syol5nE",
    d: "M12.724.083S4.392 4.559.084 7.465l.002.004s-.078.05-.052.141c0 0 .042.076.101.076v.001c1.541.002 7.381.007 7.53-.018 0 0 .755-.031 1.684-.39 0 0 2.078-.66 3.157-3.02 0 0 .962-1.925.218-4.176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__17l5dvnqaG",
    d: "M12.724.083c.744 2.25-.218 4.176-.218 4.176-1.079 2.36-3.157 3.02-3.157 3.02-.651.252-1.217.342-1.497.374H.067c-.008-.008-.015-.016-.02-.024v-.118c.016-.027.039-.042.039-.042l-.003-.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__pyw7o8i93J",
    d: "M.057 14.568s.066.05.13.011c1.405-.696 7.248-3.673 9.669-6.035 0 0 1.53-1.23 1.611-3.21.175-2.746-2.585-5.29-2.585-5.29S3.773 6.234.025 14.412h.003s-.043.095.029.156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-huawei-active_svg__h8zzsh95aL",
    d: "M8.904.065c.258.246 2.729 2.666 2.563 5.269-.081 1.98-1.611 3.21-1.611 3.21-2.42 2.362-8.264 5.339-9.668 6.035-.065.04-.131-.011-.131-.011-.072-.061-.03-.156-.03-.156H.026C3.65 6.505 8.545.457 8.865.065"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__vi12kmlzsd",
    cx: "155.12%",
    cy: "-8.988%",
    r: "200.174%",
    fx: "155.12%",
    fy: "-8.988%",
    gradientTransform: "matrix(1 0 0 .78932 0 -.019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__ed3oetkzvi",
    cx: "173.079%",
    cy: "-518.903%",
    r: "673.322%",
    fx: "173.079%",
    fy: "-518.903%",
    gradientTransform: "matrix(.33663 0 0 1.00105 1.148 .005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__dtp9lk33pn",
    cx: "154.939%",
    cy: "-123.743%",
    r: "302.159%",
    fx: "154.939%",
    fy: "-123.743%",
    gradientTransform: "matrix(.5854 0 0 1.00105 .642 .001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__ptqmvtt4xs",
    cx: "166.528%",
    cy: "16.21%",
    r: "334.893%",
    fx: "166.528%",
    fy: "16.21%",
    gradientTransform: "matrix(1 0 0 .38191 0 .1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__yy0pwd365x",
    cx: "53.632%",
    cy: "16.124%",
    r: "335.456%",
    fx: "53.632%",
    fy: "16.124%",
    gradientTransform: "matrix(1 0 0 .38171 0 .1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__1wcs3ejn5C",
    cx: "10.143%",
    cy: "-528.717%",
    r: "686.129%",
    fx: "10.143%",
    fy: "-528.717%",
    gradientTransform: "matrix(.33725 0 0 1.00105 .067 .006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__3qhlno2s5H",
    cx: "9.537%",
    cy: "-124.363%",
    r: "302.608%",
    fx: "9.537%",
    fy: "-124.363%",
    gradientTransform: "matrix(.58611 0 0 1.00106 .04 .001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ic-huawei-active_svg__jwudxi1zxM",
    cx: "17.208%",
    cy: "-8.674%",
    r: "200.655%",
    fx: "17.208%",
    fy: "-8.674%",
    gradientTransform: "matrix(1 0 0 .78845 0 -.018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FAB8A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A080D"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(2.277 4.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__22f98e5e6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__68rq9i6kla"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M11.543 14.568s.055-.044.025-.117h.002C7.823 6.258 2.698.044 2.698.044S-.09 2.693.108 5.346c.107 2.009 1.614 3.198 1.614 3.198 2.435 2.374 8.322 5.368 9.69 6.047.017.008.09.03.13-.023",
    mask: "url(#ic-huawei-active_svg__22f98e5e6b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(2.277 4.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__f3r15zep1e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__alz3tr565c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__vi12kmlzsd)",
    d: "M11.543 14.568s.055-.044.025-.117h.002C7.823 6.258 2.698.044 2.698.044S-.09 2.693.108 5.346c.107 2.009 1.614 3.198 1.614 3.198 2.435 2.374 8.322 5.368 9.69 6.047.017.008.09.03.13-.023",
    mask: "url(#ic-huawei-active_svg__f3r15zep1e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(2.91 20.743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__pe9d2ywucg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__pn6ca3n9yf"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M10.002.155c-.026-.089-.13-.089-.13-.089V.062l-9.8.343c1.063 1.898 2.855 3.37 4.72 2.92C6.078 3.003 8.991.968 9.955.278L9.953.276c.074-.067.049-.121.049-.121",
    mask: "url(#ic-huawei-active_svg__pe9d2ywucg)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(2.91 20.743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__ke1fabryuj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__faujod93sh"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__ed3oetkzvi)",
    d: "M10.002.155c-.026-.089-.13-.089-.13-.089V.062l-9.8.343c1.063 1.898 2.855 3.37 4.72 2.92C6.078 3.003 8.991.968 9.955.278L9.953.276c.074-.067.049-.121.049-.121",
    mask: "url(#ic-huawei-active_svg__ke1fabryuj)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(0 12.395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__vsgbw7r7wl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__dkfjvew3pk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M13.055 7.62c.05-.076-.035-.144-.035-.144l.002-.001C8.717 4.567.372.106.372.106c-.758 2.35.265 4.241.265 4.241C1.699 6.6 3.729 7.28 3.729 7.28c.937.387 1.874.413 1.874.413.148.025 5.832.002 7.354-.005.065 0 .098-.067.098-.067",
    mask: "url(#ic-huawei-active_svg__vsgbw7r7wl)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(0 12.395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__i5lk7e5zko",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__yxo32ddb1m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__dtp9lk33pn)",
    d: "M13.055 7.62c.05-.076-.035-.144-.035-.144l.002-.001C8.717 4.567.372.106.372.106c-.758 2.35.265 4.241.265 4.241C1.699 6.6 3.729 7.28 3.729 7.28c.937.387 1.874.413 1.874.413.148.025 5.832.002 7.354-.005.065 0 .098-.067.098-.067",
    mask: "url(#ic-huawei-active_svg__i5lk7e5zko)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(8.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__knmz635oeq",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__t8fgefdt8p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M5.108.106C4.68.145 3.529.408 3.529.408.933 1.078.321 3.436.321 3.436c-.475 1.483.012 3.113.012 3.113.865 3.846 5.128 10.168 6.046 11.495.063.066.115.043.115.043.1-.027.093-.121.093-.121C7.997 3.85 5.107.106 5.107.106",
    mask: "url(#ic-huawei-active_svg__knmz635oeq)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(8.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__7icek2apht",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__fewmyl35gr"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__ptqmvtt4xs)",
    d: "M5.108.106C4.68.145 3.529.408 3.529.408.933 1.078.321 3.436.321 3.436c-.475 1.483.012 3.113.012 3.113.865 3.846 5.128 10.168 6.046 11.495.063.066.115.043.115.043.1-.027.093-.121.093-.121C7.997 3.85 5.107.106 5.107.106",
    mask: "url(#ic-huawei-active_svg__7icek2apht)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(16.443)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__rc4zejdt5v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__q9k06tg4gu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M.51 18.083c.094.038.143-.054.143-.054h.003c.937-1.362 5.173-7.648 6.039-11.48 0 0 .465-1.859.013-3.113 0 0-.64-2.394-3.24-3.028 0 0-.747-.19-1.541-.302 0 0-2.905 3.745-1.493 17.869h.002c.01.091.075.108.075.108",
    mask: "url(#ic-huawei-active_svg__rc4zejdt5v)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(16.443)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__b38v43w1dy",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__5vpzxzcuow"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__yy0pwd365x)",
    d: "M.51 18.083c.094.038.143-.054.143-.054h.003c.937-1.362 5.173-7.648 6.039-11.48 0 0 .465-1.859.013-3.113 0 0-.64-2.394-3.24-3.028 0 0-.747-.19-1.541-.302 0 0-2.905 3.745-1.493 17.869h.002c.01.091.075.108.075.108",
    mask: "url(#ic-huawei-active_svg__b38v43w1dy)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(19.099 20.743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__0ar3kxbdxA",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__46dfql4azz"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M.176.071S.088.082.064.147c0 0-.02.088.038.132v.003c.936.674 3.781 2.663 5.153 3.052 0 0 2.533.862 4.736-2.92L.176.07V.07",
    mask: "url(#ic-huawei-active_svg__0ar3kxbdxA)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(19.099 20.743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__a9qb6ephgD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__x8tumo0uyB"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__1wcs3ejn5C)",
    d: "M.176.071S.088.082.064.147c0 0-.02.088.038.132v.003c.936.674 3.781 2.663 5.153 3.052 0 0 2.533.862 4.736-2.92L.176.07V.07",
    mask: "url(#ic-huawei-active_svg__a9qb6ephgD)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(18.972 12.395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__aa0d9ziftF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__448syol5nE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M12.724.083S4.392 4.559.084 7.465l.002.004s-.078.05-.052.141c0 0 .042.076.101.076v.001c1.541.002 7.381.007 7.53-.018 0 0 .755-.031 1.684-.39 0 0 2.078-.66 3.157-3.02 0 0 .962-1.925.218-4.176",
    mask: "url(#ic-huawei-active_svg__aa0d9ziftF)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(18.972 12.395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__67wij8e74I",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__17l5dvnqaG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__3qhlno2s5H)",
    d: "M12.724.083S4.392 4.559.084 7.465l.002.004s-.078.05-.052.141c0 0 .042.076.101.076v.001c1.541.002 7.381.007 7.53-.018 0 0 .755-.031 1.684-.39 0 0 2.078-.66 3.157-3.02 0 0 .962-1.925.218-4.176",
    mask: "url(#ic-huawei-active_svg__67wij8e74I)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(18.213 4.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__j5njpjcmpK",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__pyw7o8i93J"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9A080D",
    d: "M.057 14.568s.066.05.13.011c1.405-.696 7.248-3.673 9.669-6.035 0 0 1.53-1.23 1.611-3.21.175-2.746-2.585-5.29-2.585-5.29S3.773 6.234.025 14.412h.003s-.043.095.029.156",
    mask: "url(#ic-huawei-active_svg__j5njpjcmpK)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4) translate(18.213 4.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-huawei-active_svg__nd0gzuxndN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ic-huawei-active_svg__h8zzsh95aL"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-huawei-active_svg__jwudxi1zxM)",
    d: "M.057 14.568s.066.05.13.011c1.405-.696 7.248-3.673 9.669-6.035 0 0 1.53-1.23 1.611-3.21.175-2.746-2.585-5.29-2.585-5.29S3.773 6.234.025 14.412h.003s-.043.095.029.156",
    mask: "url(#ic-huawei-active_svg__nd0gzuxndN)"
  })))));
};
export default SvgIcHuaweiActive;